import React from "react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

const imgs = [IMAGES.gBreakfast, IMAGES.gPizza, IMAGES.gCurry, IMAGES.gTacos, IMAGES.gSoup];

export const Gallery = () => {
  const { t } = useLang();
  return (
    <section className="py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <p className="text-sm font-bold uppercase tracking-widest text-terracotta">
              {t.gallery.badge}
            </p>
            <h2 className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-petrol sm:text-4xl">
              {t.gallery.title}
            </h2>
          </div>
        </Reveal>
      </div>

      <div className="mt-10 flex gap-5 overflow-x-auto px-5 pb-4 sm:px-8" data-testid="screenshot-gallery">
        {t.gallery.captions.map((caption, i) => (
          <Reveal key={i} delay={(i % 5) * 0.06}>
            <div className="w-[240px] shrink-0 sm:w-[280px]">
              <div className="overflow-hidden rounded-[2rem] border-[8px] border-petrol bg-petrol shadow-xl">
                <img
                  src={imgs[i]}
                  alt={caption}
                  className="h-[360px] w-full object-cover sm:h-[420px]"
                  loading="lazy"
                />
              </div>
              <p className="mt-3 text-center font-heading font-bold text-petrol">
                {caption}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
